import { X } from "lucide-react";
import MagazineProfile from "@/components/MagazineProfile";

/**
 * Fullscreen preview overlay for the Add/Edit profile modals.
 * Shows the current form state rendered exactly as the public magazine profile
 * would render. Used across Institution / Supplier / EdTech admin editors.
 */
export default function ProfilePreviewOverlay({
  masthead,
  year,
  photos,
  leftHtml,
  rightHtml,
  onBack,
  testId = "profile-preview",
}) {
  return (
    <div
      className="fixed inset-0 z-[60] bg-slate-900/70 backdrop-blur-sm overflow-y-auto"
      onClick={onBack}
      data-testid={testId}
    >
      <div
        className="max-w-[1300px] mx-auto my-8 bg-white rounded-3xl shadow-2xl overflow-hidden"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between px-6 py-4 border-b border-slate-100 bg-slate-50/70">
          <div className="text-[10px] tracking-[0.32em] font-bold uppercase text-slate-500">
            Live Preview · Not saved yet
          </div>
          <button
            type="button"
            onClick={onBack}
            className="inline-flex items-center gap-1.5 px-4 py-1.5 rounded-full text-[12px] font-semibold bg-slate-900 text-white shadow-sm hover:opacity-90"
            data-testid={`${testId}-back`}
          >
            <X className="w-3.5 h-3.5" /> Back to Edit
          </button>
        </div>

        <MagazineProfile
          masthead={masthead || ""}
          year={year || new Date().getFullYear()}
          photos={photos || []}
          leftHtml={leftHtml || ""}
          rightHtml={rightHtml || ""}
          filename={masthead || "preview"}
          testId={`${testId}-magazine`}
        />
      </div>
    </div>
  );
}
